import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import HistoricEmailExistsDialog from "./HistoricEmailExistsDialog";
import { gVal } from "../../historicGuardianUtils";

function getEmailHelperText(checking, exists) {
  if (checking) return "Checking email...";
  if (exists) return "This email already exists.";
  return "";
}

function renderDebouncedEmailField({
  label,
  value,
  index,
  guardians,
  debounced,
  emailExists,
  emailChecking,
  emailDialogOpen,
  onGuardianEmailCommit,
  onDialogClose,
  onDialogCancel,
  onDialogContinue,
}) {
  return (
    <>
      <TextField
        sx={{ mb: 2 }}
        label={label}
        value={value}
        onChange={(e) =>
          onGuardianEmailCommit(index, guardians, e.target.value, debounced)
        }
        fullWidth
        required
        error={Boolean(emailExists[index])}
        helperText={getEmailHelperText(emailChecking[index], emailExists[index])}
      />
      <HistoricEmailExistsDialog
        open={emailDialogOpen[index] || false}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") onDialogClose(index);
        }}
        onCancel={() => onDialogCancel(index)}
        onContinue={() => onDialogContinue(index)}
      />
    </>
  );
}

/**
 * @param {(index:number, guardians:object[], email:string, debouncedFn:null|Function) => void} onGuardianEmailCommit
 */
export default function HistoricEmailField({
  cfg,
  keys,
  index,
  guardian,
  guardians,
  label,
  emailExists,
  emailChecking,
  emailDialogOpen,
  getDebouncedCheckEmail,
  onDialogClose,
  onDialogContinue,
  onDialogCancel,
  onGuardianEmailCommit,
}) {
  const value = gVal(guardian, keys, "email");

  if (cfg.emailUi === "newPgDebounced") {
    if (!guardian.is_new_pg) return null;
    return renderDebouncedEmailField({
      label,
      value,
      index,
      guardians,
      debounced: getDebouncedCheckEmail(index),
      emailExists,
      emailChecking,
      emailDialogOpen,
      onGuardianEmailCommit,
      onDialogClose,
      onDialogCancel,
      onDialogContinue,
    });
  }

  if (cfg.emailUi === "newPgOrAttorneyDebounced") {
    if (!(guardian.is_new_pg || guardian.is_attorney === "Yes")) return null;
    return renderDebouncedEmailField({
      label,
      value,
      index,
      guardians,
      debounced: getDebouncedCheckEmail(index),
      emailExists,
      emailChecking,
      emailDialogOpen,
      onGuardianEmailCommit,
      onDialogClose,
      onDialogCancel,
      onDialogContinue,
    });
  }

  if (!guardian.is_new_pg) return null;
  return (
    <TextField
      sx={{ mb: 2 }}
      label={label}
      value={value}
      onChange={(e) =>
        onGuardianEmailCommit(index, guardians, e.target.value, null)
      }
      fullWidth
      required
    />
  );
}

HistoricEmailField.propTypes = {
  cfg: PropTypes.object.isRequired,
  keys: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  emailExists: PropTypes.array.isRequired,
  emailChecking: PropTypes.array.isRequired,
  emailDialogOpen: PropTypes.array.isRequired,
  getDebouncedCheckEmail: PropTypes.func.isRequired,
  onDialogClose: PropTypes.func.isRequired,
  onDialogContinue: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
  onGuardianEmailCommit: PropTypes.func.isRequired,
};
